export enum AvatarSize {
  xl = 'xl',
  lg = 'lg',
  md = 'md',
  mds = 'mds',
  sm = 'sm',
  xs = 'xs',
  group = 'group',
}
